import { Grid } from '@material-ui/core';
import {
  EntityGroupProfileCard,
  EntityMembersListCard,
  EntityOwnershipCard,
} from '@backstage/plugin-org';
import { EntityLayout } from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import { EntityWarningContent } from './modules/EntityWarningContent';
import { EntityTeamPullRequestsContent } from '@backstage-community/plugin-github-pull-requests-board';

function Overview() {
  return (
    <Grid container spacing={3} alignItems="stretch">
      <EntityWarningContent />

      <Grid item xs={12} md={8}>
        <EntityOwnershipCard />
      </Grid>
      <Grid item xs={12} md={4}>
        <EntityGroupProfileCard />
      </Grid>

    </Grid>
  );
}

// Wrapped in local components so collectEntityPageContents assigns them to
// orphanRoutesPlugin (no core.plugin) rather than the org/catalog-graph alpha
// plugin instances, which would be deduplicated away before the tabs register.
function MembersTab() {
  return <EntityMembersListCard />;
}

function RelationsTab() {
  return <EntityCatalogGraphCard />;
}

export const groupPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Overview />
    </EntityLayout.Route>

    <EntityLayout.Route path="/members" title="Members">
      <MembersTab />
    </EntityLayout.Route>

    <EntityLayout.Route path="/relations" title="Relations">
      <RelationsTab />
    </EntityLayout.Route>

    <EntityLayout.Route path="/pull-requests" title="Pull Requests">
      <EntityTeamPullRequestsContent />
    </EntityLayout.Route>
  </EntityLayout>
);
